



































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import { PaymentCalculatorService } from '../services/PaymentCalculatorService'

/* eslint-disable */ 
import { Product } from '../models/Product'
import { OrderItem } from '../models/OrderItem' 
import { Dealer } from '../models/Dealer'
/* eslint-enable */ 
    
export default Vue.extend({
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/authenticated',
      frequency: 'terms/currentFrequency',
      currentTrim: 'trims/currentTrim',
      currentMake: 'makes/currentMake',
      currentModel: 'models/currentModel',
      products: 'cart/products',
      rate: 'terms/rate',
      term: 'terms/term',
      subtotal: 'cart/subtotal',
      authenticated: 'auth/authenticated',
      currentUser: 'auth/currentUser',
    }),
    currentUserId() : number {
      return this.auth ? this.currentUser.id : -1
    },
    currentDealer(): Dealer {
      return this.$store.state.dealers.currentDealer
    },
    paymentPeriods() : number {
      return PaymentCalculatorService.getPaymentPeriods(this.frequency)
    },
    payment() : number {
      return PaymentCalculatorService.calculatePayment(this.rate, this.subtotal, this.paymentPeriods, this.term)
    }
  },
  methods: {
    getProductPrice(orderItem : OrderItem) {
      return orderItem.installed ? orderItem.installedPrice + orderItem.optionPrice : orderItem.price + orderItem.optionPrice
    },
    removeProduct(product: Product) {
      if (this.authenticated) {
        this.$store.dispatch('cart/removeProductFromCart', { product: product, auth: this.authenticated, customerId: this.currentUser.id })
      } else {
        this.$store.dispatch('cart/removeProductFromCart', { product: product })
      }
    },
    updateProductQuantity(orderItem: OrderItem) {
      orderItem.total = this.totalProductPrice(orderItem)
      this.$store.dispatch('cart/updateCartWithProduct', { orderItem: orderItem, auth: this.auth, trimId: this.currentTrim.id, customerId: this.currentUserId })
    },
    decrement(orderItem: OrderItem) {
      if (orderItem.quantity > 1) {
        orderItem.quantity--
        this.updateProductQuantity(orderItem)
      }
    },
    increment(orderItem: OrderItem) {
      orderItem.quantity++
      this.updateProductQuantity(orderItem)
    },
    totalProductPrice(orderItem: OrderItem) : number {
      const price = orderItem.installed ? orderItem.installedPrice * orderItem.quantity : orderItem.price * orderItem.quantity
      const optionsTotal = orderItem.optionPrice
      return price + optionsTotal
    },
    checkout() : void {
      this.$emit('checkout')
    },
    closeCartDrawer() : void {
      this.$emit('closeCartDrawer')
    },
    continueShopping() : void {
      if (this.currentTrim) {
        this.$store.dispatch('products/reloadProducts', { trimId: this.currentTrim.id, dealerId: this.currentDealer.id })
        this.$store.dispatch('terms/getTerms', { trim: this.currentTrim, modelId: this.currentModel.id, manufacturer: this.currentDealer.manufacturerId })
        this.$router.push({ path: '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/products' })
        this.closeCartDrawer()
      } else {
        this.closeCartDrawer()
      }
    }
  }
})
